import type { EventTrackingDecorator } from '@change-corgi/core/eventTracker';

class ScreenWidthDecorator implements EventTrackingDecorator {
	// oxlint-disable-next-line class-methods-use-this
	async getEventTrackingData(): Promise<Readonly<Record<string, unknown>>> {
		return Promise.resolve({
			screen_width: getScreenWidth(),
		});
	}
}

function getScreenWidth(): number | null {
	if (typeof window === 'undefined') return null; // SSR safety

	return window.innerWidth;
}

export function createScreenWidthDecorator(): ScreenWidthDecorator {
	return new ScreenWidthDecorator();
}
